// removed by extract-text-webpack-plugin
module.exports = {"ModalWrapper":"_3iH6M9Y4u7_YdabKBUaLZ8","Header":"_3kWIkJ-hVDL9EgsbHH0QMz","Body":"HYChnzHzdkNvyAykpJyMZ"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Modal/style.css
// module id = 1364
// module chunks = 0